import { render, staticRenderFns } from "./WebChat.vue?vue&type=template&id=8e1f1586"
import script from "./WebChat.vue?vue&type=script&lang=js"
export * from "./WebChat.vue?vue&type=script&lang=js"
import style0 from "./WebChat.vue?vue&type=style&index=0&id=8e1f1586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports